import * as React from "react";
const SvgLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M23 15.41L18.42 20L23 24.59L21.59 26L15.59 20L21.59 14L23 15.41Z", fill: "#0B4566" }));
export default SvgLeft;
